// import Swiper JS
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';


// init Swiper:
const swiper = new Swiper('.swiper-homepage', {
    modules: [Pagination],
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
});
